module.exports = __webpack_public_path__ + "img/selected1-min.39448fd3.png";